import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { useAppSelector } from '../../app/hooks';
import { COLORS, isTablet } from '../../constants';
import { selectCurrentEpisode } from '../../features/currentpodcast/store/selectors';
import useOrientation from '../../hooks/useOrientation';
import CustomText from '../CustomText';
import { PlayerService } from '../Player/PlayerService';
import { PlayPauseButton } from '../PlayPauseButton';

export const PlayerControls = () => {
  const currentPodcastEpisode = useAppSelector(selectCurrentEpisode);

  // tablet specific styles
  const orientation = useOrientation();
  const isTabletLandscape = isTablet && orientation === 'LANDSCAPE';
  return (
    <View style={styles.container}>
      {/* skip backward */}
      <TouchableOpacity
        style={styles.skipButton}
        onPress={() => PlayerService.skipBackward(10)}
        activeOpacity={0.7}
      >
        <View style={styles.skipIconContainer}>
          <Image
            style={styles.skipIcon}
            source={require('../../assets/icons/skip-backward.png')}
            resizeMode="contain"
          />
          <CustomText style={styles.skipText} weight="SemiBold">
            {10}
          </CustomText>
        </View>
      </TouchableOpacity>

      <PlayPauseButton
        size={isTabletLandscape ? 50 : 60}
        iconSize={isTabletLandscape ? 32 : 39}
        podcastEpisode={currentPodcastEpisode}
        type="iconOnly"
      />

      {/* skip forward */}
      <TouchableOpacity
        style={styles.skipButton}
        onPress={() => PlayerService.skipForward(30)}
        activeOpacity={0.7}
      >
        <View style={styles.skipIconContainer}>
          <Image
            style={styles.skipIcon}
            source={require('../../assets/icons/skip-forward.png')}
            resizeMode="contain"
          />
          <CustomText style={styles.skipText} weight="SemiBold">
            {30}
          </CustomText>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: mvs(56),
  },
  skipButton: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  skipIconContainer: {
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  },
  skipIcon: {
    height: mvs(31),
    width: mvs(31),
  },
  skipText: {
    position: 'absolute',
    fontSize: mvs(11),
    color: COLORS.WHITE,
    top: mvs(10),
  },
});
